export const mobileApp_en = {
    head: "Mobile ",
    headStrong: "application",
    desc1: "Download and install the Clever app for mobile and fast work with your account. Edit, create booths and make appointments from your pocket gadgets.",
    desc2: "With the Clever app always at hand!",
}